
























































































































































import { Component, PropSync, Vue, Watch, Prop } from 'vue-property-decorator';
import { validationMixin } from 'vuelidate';
import { Validations } from 'vuelidate-property-decorators';
import { mixins } from 'vue-class-component';
import { required, requiredIf } from 'vuelidate/lib/validators';
import vSelect from 'vue-select';
import { OrgsApi, ProductsApi } from '../../api';
import Toast from '@/components/display/toast.vue';
import 'vue-ctk-date-time-picker/dist/vue-ctk-date-time-picker.css';
import { AxiosResponse } from 'axios';
import { OrdwayService } from '@/services/ordway-service';
import {
	PaymentType,
	setPaymentMethodConstraints,
	paymentMethodError,
} from '@/models/org-payment-method';
import { Organisation } from '@/models/organisation';
import { hasAccountFields } from '@/models/org-payment-method';
import { validAccountNumber } from '@/common/Validators';
import VueCtkDateTimePicker from 'vue-ctk-date-time-picker';
Vue.component('VueCtkDateTimePicker', VueCtkDateTimePicker);

@Component({
	components: {
		vSelect,
		Toast,
	},
	methods: {
		paymentMethodError,
	},
})
export default class AddBilling extends mixins(validationMixin) {
	public emailRequired = true;
	public loading = false;

	@PropSync('org') public localOrg!: Organisation;
	public paymentMethodOptions = [
		{ value: 'farmSource', text: 'Farm Source' },
		{ value: 'ruralCo', text: 'Rural Co' },
		{ value: 'directDebit', text: 'Direct Debit' },
		{ value: 'directInvoice', text: 'Direct Invoice' },
	];
	@Prop(String)
	public modeType?: string;

	public accountApprovedOptions = [
		{ value: false, text: 'Not Approved' },
		{ value: true, text: 'Approved' },
	];

	public $bvToast: any;
	public submitStatus: 'ERROR' | 'PENDING' | 'OK' | null = null;
	public region: any = null;
	public siteRegion: any = null;

	get isDirectInvoice(): boolean {
		return this.localOrg.subscription.paymentMethod === 'directInvoice';
	}

	public created() {
		this.localOrg.subscription.paymentMethod = 'directInvoice';
	}

	@Validations()
	public validations() {
		return {
			localOrg: {
				subscription: {
					paymentMethod: { required },
					accountNumber: {
						required: requiredIf(() =>
							hasAccountFields(this.localOrg.subscription.paymentMethod as PaymentType),
						),
						validAccountNumber: validAccountNumber(
							this.localOrg.subscription.paymentMethod as PaymentType,
						),
					},
					accountName: {
						required: requiredIf(() =>
							hasAccountFields(this.localOrg.subscription.paymentMethod as PaymentType),
						),
					},

					accountApproved: {
						required: requiredIf(() => {
							return this.localOrg.subscription.paymentMethod !== 'directInvoice';
						}),
					},
				},
			},
		};
	}

	@Watch('localOrg')
	public updateLocalOrg() {
		if (this.localOrg.subscription === null) {
			this.localOrg.subscription = {
				id: '',
				paymentMethod: '',
				accountApproved: false,
				// directDebitDate:
				accountName: '',
				accountNumber: '',
				paymentMethodActive: false,
			};
		}
	}

	@Watch('localOrg.subscription.paymentMethod', { deep: true, immediate: true })
	public setPaymentMethodConstraints() {
		setPaymentMethodConstraints(this.localOrg.subscription);
	}

	@Watch('localOrg.subscription.paymentMethodActive', { deep: true })
	public ensurePaymentMethodApproved(paymentMethodActive: boolean) {
		if (paymentMethodActive) {
			this.localOrg.subscription.accountApproved = true;
		}
	}

	public isValid(field) {
		return field && field.$dirty ? !field.$invalid : null;
	}

	public stepValidate(name: string) {
		const form = this.$v[name];
		form.$touch();
		if (!form.$invalid) {
			this.onComplete();
		}
	}

	public async onComplete(...a: any[]) {
		this.submitStatus = 'PENDING';
		delete this.localOrg.subscription.id;
		if (this.localOrg.subscription.paymentMethod !== 'directDebit') {
			this.localOrg.subscription.directDebitDate = null;
		}
		if (['directInvoice'].includes(this.localOrg.subscription.paymentMethod)) {
			this.localOrg.subscription.accountName = null;
			this.localOrg.subscription.accountNumber = null;
			this.localOrg.subscription.accountApproved = false;
		}

		try {
			const promise = await new OrgsApi().updateOrg(parseInt(this.org.id, 10), {
				data: this.localOrg.subscription,
			});
		} catch (e) {
			let error;
			if (e.response) {
				if (e.response.data.message) {
					error = 'billing not created ' + e.response.data.message;
				} else {
					error = 'billing not created unknown error, check response';
				}
			} else if (e.request) {
				error = 'billing not created, network Error';
			} else {
				error = 'billing not created, unknown Error';
			}
			new Toast().makeToast(error, 'Error Adding billing', 'danger', true);
			this.submitStatus = 'ERROR';
			return;
		}
		try {
			await this.updateDefaultPaymentMethod(
				parseInt(this.localOrg.id, 10),
				this.localOrg.subscription.paymentMethod as PaymentType,
				this.localOrg.subscription.accountApproved,
				this.localOrg.subscription.paymentMethodActive,
				this.localOrg.subscription.accountName,
				this.localOrg.subscription.accountNumber,
			);
		} catch (e) {
			new Toast().makeToast(
				'There was an error updating the payment method for this contact in Ordway, please retry or let the software team know',
				'Error updating Ordway payment method',
				'danger',
				true,
			);
			this.submitStatus = 'ERROR';
			return;
		}

		this.submitStatus = 'OK';

		new Toast().makeToast('Billing Added', 'Billing Added', 'success');
		this.$emit('nextTab');
		this.$emit('load');
	}

	private async updateDefaultPaymentMethod(
		orgId: number,
		type: PaymentType,
		billingApproved: boolean,
		paymentMethodActive: boolean,
		accountName?: string,
		accountNumber?: string,
	): Promise<AxiosResponse<any>> {
		return await OrdwayService.updateDefaultPaymentMethod(
			orgId,
			type,
			billingApproved,
			paymentMethodActive,
			accountName,
			accountNumber,
		);
	}
}
